module.exports = __webpack_public_path__ + "img/mind_file_icon.45484417.svg";